import React from "react"
import emptyBoxImage from '../../resources/images/blank_canvas_pana.png'

export const EmptyResultSet = ({ description, image = null }) => {

    return (
        <React.Fragment>
            <div className="md:my-6 my-4 py-3 px-4">
                <div className="flex flex-col items-center">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center w-40 md:w-44 lg:w-52 pb-3">
                        <img src={image ?? emptyBoxImage} alt="broken_robot" width="auto" className="block text-center m-auto" />
                    </div>

                    <div className="text-center m-auto text-slate-700 dark:text-slate-200 max-w-[512px] text-sm">
                        {description}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}